export class ScadsysIntegrationConfig {
    schoolId?: string;
    url?: string;
    pageSize?: string;
    token?: string;
    excelFileData?: string;
    domain: string;

    constructor(config) {
        let _config = config || {};
        this.schoolId = _config.schoolId || "";
        this.url = _config.url || "https://";
        this.pageSize = _config.pageSize || "0";
        this.token = _config.token || "";
        this.domain = _config.domain || "";
    }
}

export class ScadsysIntegration {
    config: ScadsysIntegrationConfig;
    name: string;
    integrationDirection: number;
    integrationType: number;
    integrationId: number;
    triggerId: string;
    triggerLastRun: string;
    triggerEnabled: boolean;
    organizationId: string;
    priority: number;

    constructor(integration: any = {}) {
        this.name = integration.name || "";
        this.integrationDirection = integration.integrationDirection;
        this.integrationType = integration.integrationType;
        this.integrationId = integration.integrationId;
        this.triggerId = integration.triggerId;
        this.triggerLastRun = integration.triggerLastRun;
        this.triggerEnabled = integration.triggerEnabled;
        this.organizationId = integration.organizationId;
        this.priority = integration.priority;

        this.config = new ScadsysIntegrationConfig(integration.config);
    }
}

export interface ScadsysUserState extends ScadsysState {
    users: any;
    totals: {
        users: number;
    };
    syncResult: any;
}

export interface ScadsysGroupState extends ScadsysState {
    groups: any;
    groupMemberships: any;
    totals: {
        groups: number;
        memberships: number;
    };
}

export interface ScadsysPhotoState extends ScadsysState {
    photos: any;
    totals: {
        photos: number;
    };
}

export interface ScadsysState {
    profiles: Array<ScadsysIntegration>;
    selectedProfile: ScadsysIntegration;
    selectedProfileId: string;
}

export interface ScadsysProps {
    organization: string;
}
